export function toggle<T>(list: T[], value: T) {
    return list.includes(value) ? list.filter((v) => v !== value) : [...list, value]
}

export function normalizeWord(word: string) {
    return word.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase()
}

export function formatMes(mes: string) {
    const [ano, m] = mes.split('-')
    const nomes = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']
    return `${nomes[Number(m) - 1] ?? m}/${ano.substring(2)}`
}

export function errorMessage(caught: unknown) {
    const message = (caught as { message?: string })?.message
    return message ? `Não foi possível carregar os dados: ${message}` : 'Não foi possível carregar os dados.'
}
